import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    title: 'Plan concreto para cuando tu mente arranca',
    desc: 'Ya no más dar vueltas en la cama sin saber qué hacer.'
  }, {
    title: 'Protocolo 3:00am',
    desc: 'Saber exactamente qué hacer si te despiertas a mitad de noche.'
  }, {
    title: 'Reduce la ansiedad anticipatoria',
    desc: "Deja de pensar 'otra vez no voy a dormir'."
  }, {
    title: 'Rutina sostenible',
    desc: 'Funciona incluso en tus semanas más pesadas.'
  }];
  return <div className="py-16 px-4 sm:px-6 bg-cream-50" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-navy-900 mb-4" data-id="element-3">
          Lo que vas a conseguir
        </motion.h2>
        <p className="text-center text-navy-600 mb-12 text-lg" data-id="element-4">
          (sin promesas mágicas)
        </p>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-5">
          {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-cream-200" data-id="element-6">
              <div className="flex items-start" data-id="element-7">
                <div className="bg-amber-100 p-2 rounded-lg mr-4" data-id="element-8">
                  <Zap className="w-5 h-5 text-amber-600" data-id="element-9" />
                </div>
                <div data-id="element-10">
                  <h3 className="font-bold text-navy-900 mb-2" data-id="element-11">
                    {benefit.title}
                  </h3>
                  <p className="text-navy-600 text-sm" data-id="element-12">{benefit.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}